/// \file multiSelectDropdownBar.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import * as React from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";

//id will have the id of the dropdown
//data will contain all potential options in the dropdown
//onFilterChange will contain the onFilterChange event for if the dropdown changes
//onChange will hold the onChangeEvent for the dropdown bar
//placeholder will hold the text to show if no value is selected
//value will hold the value selected from the user
export const MultiSelectDropdownBar = (props:{
  id:string, //id of the dropdown
  data:string[], //all potential options in the dropdown
  placeholder:string, //hold the text to show if no value is selected
  value:string[], //hold the value selected from the user
  onFilterChange:(e:any) =>void, //contain the onFilterChange event for if the dropdown changes
  onChange:(e:{value:null|string[]}) =>void //hold the onChangeEvent for the dropdown bar
}) => {
    const id = props.id;
    const data = props.data;
    const onFilterChange = props.onFilterChange;
    const placeholder = props.placeholder;
    const values = props.value;
    const onChange = props.onChange;
    return (
      <MultiSelect
        id = {id}
        filterable={true}
        onChange={onChange}
        onFilterChange={onFilterChange}
        data={data}
          style={{
            width: "91%",
          }}
          placeholder={placeholder}
          value={values}
        />
    );
};